<script setup>
import { computed } from 'vue'

const props = defineProps({
  tour: { type: [Object, null], default: {}, required: true },
})

// const isUpcoming  = computed(() => !!props.tour['upcoming?'] )
// const isFinalized = computed(() => !!props.tour['finalized?'] )
// const isPending   = computed(() => !!props.tour['pending?'] )
</script>

<template lang="pug">
Tag(v-if="props.tour.isUpcoming" value="Upcoming" severity="info" rounded) 
Tag(v-else-if="props.tour.isFinalized" value="Finalized" severity="contrast" rounded) 
Tag(v-else-if="props.tour.isPending" value="Pending" severity="warn" rounded) 
Tag(v-else value="???" severity="secondary" rounded)
//- pre {{ props.tour['pending?'] }}
</template>